import type {PublicMethodUtils} from '@wix/document-services-types'
import type {FeaturesPublicAPI} from '@wix/document-services-public-types'
import {features} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<FeaturesPublicAPI> {
    const {
        extensionPublicAPI: {constants}
    } = publicMethodUtils

    return {
        methods: {
            components: {
                features: {
                    FEATURE_TYPES: constants('features.components.FEATURE_TYPES'),
                    get: publicMethodUtils.defineGetter(features.getFeatureData),
                    update: publicMethodUtils.defineDataManipulationAction(features.updateFeatureData),
                    remove: publicMethodUtils.defineDataManipulationAction(features.removeComponentFeatureData),
                    getAllCompsInPageBasedOnFeatureType: publicMethodUtils.defineGetter(
                        features.getAllCompsInPageBasedOnFeatureType
                    )
                }
            },
            page: {
                features: {
                    FEATURE_TYPES: constants('features.page.FEATURE_TYPES'),
                    get: publicMethodUtils.defineGetter(features.page.get),
                    update: publicMethodUtils.defineDataManipulationAction(features.page.update),
                    remove: publicMethodUtils.defineDataManipulationAction(features.page.remove)
                }
            },
            site: {
                features: {
                    FEATURE_TYPES: constants('features.site.FEATURE_TYPES'),
                    get: publicMethodUtils.defineGetter(features.site.get),
                    update: publicMethodUtils.defineDataManipulationAction(features.site.update),
                    remove: publicMethodUtils.defineDataManipulationAction(features.site.remove)
                }
            }
        }
    }
}
